import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import { authModule, application } from '@/store'
import clickOutside from '@/components/directives/click-outside'
import { useVuetify } from '@/composables/vuetify'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBottomNav',
  setup(__props) {

const vClickoutside = clickOutside

const vuetify = useVuetify()

const bottomNav = ref(null)
const expandido = ref(false)

const itensMenuIniciais = computed(() => authModule.activeMenus.slice(0, 3))

const itensMenuAdicionais = computed(() => authModule.activeMenus.slice(3))

const navHeight = computed(() => !expandido.value || vuetify.breakpoint.smAndUp
	? 56
	: 56 + Math.ceil((itensMenuAdicionais.value.length + 1) / 4) * 56)

watch(navHeight, (altura) => {
	vuetify.application.bottom = altura
}, { immediate: true })

function temConteudoNovoItem(item: typeof authModule['activeMenus'][0]) {
	if (item.nome === 'Home') return application.temNovidades
	return false
}

return { __sfc: true,vClickoutside, vuetify, bottomNav, expandido, itensMenuIniciais, itensMenuAdicionais, navHeight, temConteudoNovoItem, authModule }
}

})